export const initType = () => {
    //return 'PAYMENT';
    return 'ADMIN';
}